import { render } from "./EventDetails.vue?vue&type=template&id=318bd1f0"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=318bd1f0&lang=css"
import "./EventDetails.vue?vue&type=style&index=1&id=318bd1f0&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__